export default {
  otherCategory: 'Ostatné ({count})',
};
